import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Flash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.578.551c.42.233.628.723.503 1.188l-4.754 17.776h6.827a1.046 1.046 0 0 1 .766 1.761l-21.223 22.81a1.046 1.046 0 0 1-1.777-.985l4.754-17.776H9.847a1.047 1.047 0 0 1-.765-1.761L30.305.754A1.046 1.046 0 0 1 31.578.55Zm-19.326 22.68h5.786a1.046 1.046 0 0 1 1.01 1.318l-4.02 15.032L31.75 21.61h-5.785a1.046 1.046 0 0 1-1.011-1.319l4.02-15.032-16.72 17.971Z"
  }));
});
Flash.displayName = 'Flash';
Flash.defaultProps = {
  'aria-label': 'Flash'
};
export default Flash;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Flash.js
// module id = 3166
// module chunks = 11